import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex h-full flex-col rounded-2xl border border-mist bg-white p-6 shadow-[0_1px_2px_rgba(16,19,23,0.04),0_16px_36px_-24px_rgba(16,19,23,0.3)]" data-id="element-265" data-mp="2p886j748smfx">
      <div className="flex items-center justify-between" data-id="element-266" data-mp="386amyxiq5b24">
        <QuoteIcon className="h-6 w-6 fill-crimson/10 text-crimson" aria-hidden="true" data-id="element-267" data-mp="385rgccyiy93e" />
        <span className="flex gap-0.5 text-amber" aria-label="5 out of 5 stars" data-id="element-268" data-mp="19sir3r721bp2">
          {Array.from({
          length: 5
        }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-269" data-mp="1ducmbjyhdnhu" data-mpi={k} />)}
        </span>
      </div>
      <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-graphite" data-id="element-270" data-mp="d1ktnlj93024">“{testimonial.quote}”</blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-mist pt-4" data-id="element-271" data-mp="82858wcqdkxf">
        <img src={testimonial.img} alt={testimonial.name} width={48} height={48} loading="lazy" decoding="async" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-crimson/25" data-id="element-272" data-mp="34gfa7vnc8vv" />
        <div className="min-w-0" data-id="element-273" data-mp="qtivrcejnvos">
          <p className="text-sm font-bold text-obsidian" data-id="element-274" data-mp="qspxkztniei9">{testimonial.name}</p>
          <p className="mt-0.5 flex items-center gap-1.5 text-xs text-graphite" data-id="element-275" data-mp="luocyagku74o">
            <span data-id="element-276" data-mp="3bjqf19c2d20h">📍 {testimonial.location}</span>
            <span aria-hidden="true" data-id="element-277" data-mp="3bkjdln0vcl7j">{testimonial.flag}</span>
          </p>
        </div>
      </figcaption>
    </motion.figure>;
}